export default __webpack_public_path__ + "static/media/banner-home-4.f65a539f.png";